
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Karlsson_postoperative_efficacy_scoring_criteria',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Karlsson_postoperative_efficacy_scoring_criteria.vue